export enum FACEBOOK_EVENTS {
  PAYMENT_SUCCESSFUL = "payment_successful",
  FORM2_BUSINESS_DETAILS = "form-2_business_details",
  FORM1_SIGN_UP = "form-1_sign_Up",
}

export enum FACEBOOK_STANDARD_EVENTS {
  PAGE_VIEW = "PageView",
  LEAD = "Lead",
  PURCHASE = "Purchase",
  VIEW_CONTENT = "ViewContent",
}
